import createPerformanceEvent from './create-performance-event';
import { navigationTiming } from './entries';


/**
 * @callback sendClientEvent
 * @see
 * {@link https://github.com/buzzfeed/mono/tree/master/packages/frontend/client-event-tracking}
 */

/**
 * This function is provided as a convenience for tracking the navigation timing event.
 * @param  {sendClientEvent}
 * @param  {Object} [options={}] - Configuration object
 * @param  {Array} [options.layers=[]] - An array containing an object or a function that returns an object representing fields to be sent to CET
 * @param  {Number} [options.sample_rate=0.1] - Rate at which to sample event requests (between 0 and 1)
 */
const trackNavigationTiming = (sendClientEvent, { layers = [], sample_rate = 0.1 } = {}) => {
  const options = {
    layers,
    sample_rate,
    type: 'web_performance_navigation_timing',
  };

  navigationTiming(
    createPerformanceEvent(sendClientEvent, options)
  );
};

export default trackNavigationTiming;
